import React from "react";
import "./HomeExpComp.css";
import Slider from "react-slick";
import { IoArrowBackCircle, IoArrowForwardCircle } from "react-icons/io5";
import { Link } from "react-router-dom";
import HEC2 from './HEC2.jpeg'
export function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <IoArrowForwardCircle
      className={"nextExp"}
      style={{
        display: "block",
        boxShadow: "2px 2px 2px 2px black",
        borderRadius: "50%",
        width: 30,
        height: 30,
      }}
      onClick={onClick}
    />
  );
}

export function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <IoArrowBackCircle
      className={"prevExp"}
      style={{
        display: "block",
        boxShadow: "2px 2px 2px 2px black",
        borderRadius: "50%",
        width: 30,
        height: 30,
      }}
      onClick={onClick}
    />
  );
}

const HomeExpComp = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  var firstImg =
  "https://www.rentbyowner.com/static/images/sites/rentbyowner/destination_summer_1x.webp"
    // "https://images.unsplash.com/photo-1596120236172-231999844ade?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8dmFjYXRpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60";
  var secondImg =
    "https://images.unsplash.com/photo-1602088113235-229c19758e9f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHZhY2F0aW9ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60";
  var thirdImg =
    "https://images.unsplash.com/photo-1613425653628-23fd58c3c2b1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fHZhY2F0aW9ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60";
  var fourthImg =
    "https://images.unsplash.com/photo-1548957175-84f0f9af659e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fHZhY2F0aW9ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60";

  return (
    <div style={{ marginTop: "50px" }}>
      <Slider
        {...settings}
        autoplay={true}
        autoplaySpeed={5000}
        // zIndex={2}
        className={"homeImgCompCar"}
        // centerPadding={'40px'}
        prevArrow={<SamplePrevArrow />}
        // nextArrow={<AiFillStar style={{height:50,width:50}} />}
        nextArrow={<SampleNextArrow />}
        dots={false}
        arrows={false}
    pauseOnHover={true}

      >
        <div style={{ border: "1px solid white" }}>
          <img src={firstImg} className="homeExpImg" />
          <div
            className="HomeExpCompDetailsDiv"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
          >
            <h1>Explore</h1>
            <h4>Summer Destination</h4>
            <Link to="search" className="flexibleExpComp1">
              I'm flexible
            </Link>
          </div>
        </div>
        <div style={{ border: "1px solid white" }}>
          <img src={HEC2} className="homeExpImg" />
          <div
            className="HomeExpCompDetailsDiv"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
          >
            <h1>Become A Broker</h1>
            <h4>Get Befnifits and Money Share</h4>
            <Link to="broker/login" className="flexibleExpComp1">
              List your asset
            </Link>
          </div>
        </div>
        {/* <div>
<img  src={thirdImg} className='homeExpImg' />
</div>
<div>
<img  src={fourthImg} className='homeExpImg' />
</div> */}
      </Slider>
    </div>
  );
};

export default HomeExpComp;
